import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Carousel from 'hero-carousel';
import LogInModal from 'flarum/forum/components/LogInModal';

export default class HeaderSlideCarousel extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.bodyClass = 'App--page';
    this.loading = true;
    this.categories = [];
    this.carousel;
    this.currentSlideIndex = 0;

    this.currentHeadSlideShow = app.data.currentHeadSlideShow;
    

    // app.store.find('headSlideShow'
    // // ,{ filter: { pkgId: app.session.pkgLogo.id() } }
    // )
    // .then((res) => {
    //   this.categories = app.store
    //     .all('headSlideShowCategories')
    //     .filter((headSlideShow) => (headSlideShow.pkgId = app.data.pkgLogo.id))
    //     .sort((a, b) => a.id() - b.id());
    //     this.currentHeadSlideShow = this.categories[0];
    //   this.loading = false;
    //   m.redraw();
    // });
  }
  oncreate(){
    // 设置初始状态
    this.currentSlideIndex = 0;
    
    // 延迟初始化轮播图，确保DOM已经渲染
    setTimeout(() => {
      const carouselElement = document.querySelector('.carousel');
      if (carouselElement && carouselElement.querySelector('.carousel__slides')) {
        try {
          this.carousel = new Carousel(carouselElement, (this.currentHeadSlideShow.transitionTime * 1000) || 5000);
          
          // 监听轮播图切换事件 - 通过监听DOM变化
          this.observeSlideChanges();
          
        } catch (error) {
          console.error('Carousel initialization failed:', error);
          // 如果轮播图初始化失败，至少让文本项能工作
          this.carousel = null;
        }
      } else {
        console.warn('Carousel element not found');
        this.carousel = null;
      }
      
      m.redraw();
    }, 500);
  }
  
  // 监听轮播图切换事件
  observeSlideChanges() {
    if (this.carousel && this.carousel.slides) {
      this.observer = new MutationObserver(() => {
        const activeSlide = this.carousel.slides.querySelector('.carousel__slide--current');
        if (activeSlide) {
          const slides = Array.from(this.carousel.slides.children);
          const index = slides.indexOf(activeSlide);
          if (index !== -1 && index !== this.currentSlideIndex) {
            this.currentSlideIndex = index;
            m.redraw();
          }
        }
      });
      
      this.observer.observe(this.carousel.slides, {
        attributes: true,
        childList: false,
        subtree: true,
        attributeFilter: ['class']
      });
    }
  }
  
  onremove() {
    // 清理观察器
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  
  // 点击左侧文本项切换轮播图
  switchSlide(index) {
    this.currentSlideIndex = index;
    
    // 如果轮播图已初始化，使用轮播图的方法切换
    if (this.carousel && typeof this.carousel.handleControls === 'function') {
      try {
        this.carousel.handleControls(null, index);
      } catch (error) {
        console.error('Carousel switch failed:', error);
      }
    } else {
      // 如果轮播图未初始化，手动更新DOM
      this.updateSlideManually(index);
    }
    
    m.redraw();
  }
  
  // 手动更新轮播图显示
  updateSlideManually(index) {
    const carouselElement = document.querySelector('.carousel');
    if (carouselElement) {
      const slides = carouselElement.querySelectorAll('.carousel__slide');
      slides.forEach((slide, i) => {
        if (i === index) {
          slide.classList.add('carousel__slide--current');
        } else {
          slide.classList.remove('carousel__slide--current');
        }
      });
    }
  }
  multilingual(name) {
    if (!name) return '';
    let data = JSON.parse(name);
    return data[app.data.locale];
  }
  view() {
    // const categories = this.currentHeadSlideShow;
    let category = this.currentHeadSlideShow;
    
    let objOne = null;
    let mapOne = new Map();
    let imageOne = '';
    let imageTwo = '';
    let imageThree = '';
    let imageFour = '';
    let objOnePc = '';
    if (category) {
      if (app.store.models.type != 'phone') {
        objOne = JSON.parse(category.imageOne);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('pc');
        imageOne = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageTwo);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('pc');
        imageTwo = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageThree);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('pc');
        imageThree = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageFour);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('pc');
        imageFour = objOnePc[app.data.locale];
      } else {
        objOne = JSON.parse(category.imageOne);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('phone');
        imageOne = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageTwo);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('phone');
        imageTwo = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageThree);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('phone');
        imageThree = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageFour);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('phone');
        imageFour = objOnePc[app.data.locale];
      }
    }
    const centerOnClick = (event) => {
      // if (!app.session.user) {
      //   event.preventDefault();
      //   app.modal.show(LogInModal);
      //   return;
      // }
    };
    
    let url = app.forum.attribute('baseUrl');
    
    // 准备左侧文本项数据
    const textItems = [];
    if (category) {
      if (category.imageOne) textItems.push({ title: this.multilingual(category.titleOne) || '', link: category.linkOne });
      if (category.imageTwo) textItems.push({ title: this.multilingual(category.titleTwo) || '', link: category.linkTwo });
      if (category.imageThree) textItems.push({ title: this.multilingual(category.titleThree) || '', link: category.linkThree });
      if (category.imageFour) textItems.push({ title: this.multilingual(category.titleFour) || '', link: category.linkFour });
    }
    
    return (
      <div className="carousel-container">
        {/* 左侧文本项列表 */}
        <div className="carousel-text-list">
          {textItems.map((item, index) => (
            <div 
              key={index}
              className={`carousel-text-item ${this.currentSlideIndex === index ? 'active' : ''}`}
              onclick={() => this.switchSlide(index)}
            >
              {item.title}
            </div>
          ))}
        </div>
        
        {/* 轮播图区域 */}
        <div className="carousel">
          <div className="carousel__slides" tabindex="0">
            <div className={`carousel__slide image-placeholder ${this.currentSlideIndex === 0 ? 'carousel__slide--current' : ''}`}>
              {this.loading && category && category.imageOne && (
                <a onclick={centerOnClick} href={category.linkOne ? (category.linkOne && (category.linkOne.includes('http') ? category.linkOne : url + category.linkOne)) : '#'}>
                  <img class="carousel__slide-image lazy" onload={function(){
                    this.classList.remove('lazy')
                    this.classList.add('lazy-loaded')
                    }} src={imageOne} />
                </a>
              )}
            </div>
            <div className={`carousel__slide image-placeholder ${this.currentSlideIndex === 1 ? 'carousel__slide--current' : ''}`}>
              {this.loading && category && category.imageTwo && (
                <a onclick={centerOnClick} href={category.linkTwo ? (category.linkTwo && (category.linkTwo.includes('http') ? category.linkTwo : url + category.linkTwo)) : '#'}>
                  <img class="carousel__slide-image lazy" onload={function(){
                    this.classList.remove('lazy')
                    this.classList.add('lazy-loaded')
                    }} src={imageTwo} />
                </a>
              )}
            </div>

            <div className={`carousel__slide image-placeholder ${this.currentSlideIndex === 2 ? 'carousel__slide--current' : ''}`}>
              {this.loading && category && category.imageThree && (
                <a onclick={centerOnClick} href={category.linkThree ? (category.linkThree && (category.linkThree.includes('http') ? category.linkThree : url + category.linkThree)) : '#'}>
                  <img class="carousel__slide-image lazy" onload={function(){
                    this.classList.remove('lazy')
                    this.classList.add('lazy-loaded')
                    }} src={imageThree} />
                </a>
              )}
            </div>
            <div className={`carousel__slide image-placeholder ${this.currentSlideIndex === 3 ? 'carousel__slide--current' : ''}`}>
              {this.loading && category && category.imageFour && (
                <a onclick={centerOnClick} href={category.linkFour ? (category.linkFour && (category.linkFour.includes('http') ? category.linkFour : url + category.linkFour)) : '#'}>
                  <img class="carousel__slide-image lazy" onload={function(){
                    this.classList.remove('lazy')
                    this.classList.add('lazy-loaded')
                    }} src={imageFour} />
                </a>
              )}
            </div>
          </div>
          <div className="carousel__controls"></div>
        </div>
      </div>
    );
  }
}
